import React, { Component } from "react";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";

import { removeMessage } from "../state/app/appActions";

class PublicSnackbarListener extends Component {
  // TODO: Remover esse método UNSAFE
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.messageDataList !== nextProps.messageDataList) {
      nextProps.messageDataList.forEach((messageData) => {
        const { message, ...params } = messageData;
        this.props.removeMessage(messageData);
        this.props.enqueueSnackbar(message, { ...params });
      });
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  messageDataList: state.app.messageDataList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ removeMessage }, dispatch);

export default compose(
  withSnackbar,
  connect(mapStateToProps, mapDispatchToProps)
)(PublicSnackbarListener);
